'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useState } from 'react';
import { getSandboxLoginUrl } from '@/lib/keycloak/sandbox-implicit-auth';
const authBackdropStyle = {
  backgroundImage: 'url(/genesys-bg.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed'
} as const;
interface SandboxAuthProps {
  redirectUrl?: string;
}
export default function SandboxAuth(t0) {
  const $ = _c(15);
  const {
    redirectUrl: t1
  } = t0;
  const redirectUrl = t1 === undefined ? "/dashboard" : t1;
  const [isLoading, setIsLoading] = useState(false);
  let t2;
  if ($[0] !== redirectUrl) {
    t2 = async () => {
      setIsLoading(true);
      const loginUrl = getSandboxLoginUrl(redirectUrl);
      const electronAPI = (window as any).electronAPI;
      const isElectron = typeof window !== "undefined" && electronAPI !== undefined;
      if (isElectron) {
        ;
        try {
          await electronAPI.os.openUrl(loginUrl);
          setIsLoading(false);
        } catch (t3) {
          const error = t3;
          console.error("[auth] Failed to open URL in system browser:", error);
          setIsLoading(false);
        }
      } else {
        window.location.href = loginUrl;
      }
    };
    $[0] = redirectUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleSandboxLogin = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute inset-0 bg-black/30" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-center items-center shrink-0 opacity-70 w-40 h-6 sm:w-48 sm:h-7 md:w-56 md:h-8 lg:w-64 lg:h-10"><Image src="/ProductLogo.svg" alt="Genesys" width={299} height={27} className="w-full h-full object-contain" /></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h1 className="text-white text-xl font-semibold text-center mb-1">Sign in to genesys.ai</h1>;
    t6 = <p className="text-white/60 text-sm text-center mb-6">Welcome back! Please sign in to continue</p>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isLoading) {
    t7 = isLoading ? <><div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />Redirecting to Sandbox...</> : <><svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>Continue with Sandbox</>;
    $[6] = isLoading;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== handleSandboxLogin || $[9] !== isLoading || $[10] !== t7) {
    t8 = <button type="button" onClick={handleSandboxLogin} disabled={isLoading} className="w-full flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 disabled:from-blue-600/50 disabled:to-purple-600/50 disabled:cursor-not-allowed rounded-lg py-3 px-4 text-white text-base font-semibold transition-all shadow-lg hover:shadow-xl">{t7}</button>;
    $[8] = handleSandboxLogin;
    $[9] = isLoading;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mt-6 text-center"><p className="text-white/40 text-xs">By signing in, you agree to our Terms of Service and Privacy Policy</p></div>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8) {
    t10 = <div className="fixed inset-0 flex items-center justify-center" style={authBackdropStyle}>{t3}<div className="relative z-10 flex flex-col items-center gap-6 sm:gap-8 px-4 py-8 sm:px-0 sm:py-0">{t4}<div className="w-full max-w-[400px] bg-neutral-900/95 border border-white/10 rounded-xl p-6 shadow-2xl">{t5}{t6}{t8}{t9}</div></div></div>;
    $[13] = t8;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}